import axiosInstance from "../api/axiosInstance";

const handleApiError = (error) => {
  let errorMessage = 'Bir hata oluştu';
  
  if (error.response) {
    // API'den bir yanıt geldi ancak 2xx kapsamı dışında bir durum kodu ile
    errorMessage = error.response.data?.message || error.response.data?.error || `Hata: ${error.response.status}`;
  } else if (error.request) {
    // İstek yapıldı ancak hiçbir yanıt alınamadı
    errorMessage = 'Sunucudan yanıt alınamadı';
  }
  
  console.error('API Hatası:', errorMessage, error);
  
  return {
    succeeded: false,
    message: errorMessage,
    products: []
  };
};

const productService = new (class ProductService {
  async getProducts(query = {}) {
    try {
      const response = await axiosInstance.get("/products/list", { params: query });
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getProductById(id) {
    try {
      const response = await axiosInstance.get(`/products/detail/${id}`);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getProductBySlug(slug) {
    try {
      const response = await axiosInstance.get(`/products/detail/${slug}`);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getFeaturedProducts(count = 8) {
    try {
      const response = await axiosInstance.get("/products/list", { 
        params: { 
          isFeatured: true,
          pageSize: count 
        } 
      });
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getNewProducts(count = 8) {
    try {
      const response = await axiosInstance.get("/products/list", { 
        params: { 
          isNew: true,
          pageSize: count 
        } 
      });
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  async searchProducts(searchTerm) {
    try {
      const response = await axiosInstance.get("/products/list", { 
        params: { searchTerm } 
      });
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getDiscountedProducts(count = 8) {
    try {
      const response = await axiosInstance.get("/products/list", {
        params: { 
          isDiscounted: true,
          pageSize: count 
        }
      });
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  // Get the maximum product price, optionally filtered by categoryId
  async getMaxPrice(categoryId = null) {
    try {
      const response = await axiosInstance.get("/products/max-price", { params: { categoryId } });
      return response.data;
    } catch (error) {
      console.error('MaxPrice API error:', error);
      return { succeeded: false, message: 'Fiyat bilgisi alınamadı', maxPrice: 0 };
    }
  }

  async getBestSellingProducts(count = 8) {
    try {
      const response = await axiosInstance.get("/products/best-selling", { 
        params: { count } 
      });
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
})();

export default productService; 